(function () {
  function ready(fn) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn);
    else fn();
  }

  ready(function () {
    var menu = document.querySelector('[data-menu-toggle]');
    var nav = document.getElementById('MobileNav');
    if (menu && nav) {
      menu.addEventListener('click', function () {
        var open = nav.hasAttribute('hidden');
        if (open) nav.removeAttribute('hidden');
        else nav.setAttribute('hidden', '');
        menu.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    }

    document.querySelectorAll('[data-thumb]').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var image = document.querySelector('[data-gallery-main] img');
        if (!image) return;
        image.src = thumb.getAttribute('data-thumb');
        image.removeAttribute('srcset');
      });
    });

    var select = document.querySelector('[data-variant-select]');
    if (select) {
      select.addEventListener('change', function () {
        var option = select.options[select.selectedIndex];
        var price = document.querySelector('[data-price]');
        var stock = document.querySelector('[data-stock]');
        var sku = document.querySelector('[data-sku]');
        var add = document.querySelector('[data-add]');
        var available = option.getAttribute('data-available') === 'true';
        var compare = option.getAttribute('data-compare') || '';
        var amount = option.getAttribute('data-price') || '';
        if (price) {
          price.innerHTML = compare
            ? '<s>' + compare + '</s> <strong class="price--sale">' + amount + '</strong>'
            : '<strong>' + amount + '</strong>';
        }
        if (stock) stock.textContent = available ? 'In stock' : 'Sold out';
        if (sku) sku.textContent = option.getAttribute('data-sku') || '';
        if (add) {
          add.disabled = !available;
          add.textContent = available ? 'Add to Cart' : 'Sold out';
        }
      });
    }

    var whatsapp = document.querySelector('[data-wa-btn]');
    if (whatsapp) {
      whatsapp.addEventListener('click', function () {
        var root = document.querySelector('[data-product]');
        if (!root) return;
        var number = (root.getAttribute('data-wa') || '').replace(/\D/g, '');
        var name = root.getAttribute('data-name') || '';
        var url = root.getAttribute('data-url') || window.location.href;
        var qty = document.querySelector('[data-qty]');
        var text = 'Assalam-o-Alaikum, I would like to order ' + name + '. Quantity: ' + (qty ? qty.value : '1') + '. ' + url;
        window.open('https://wa.me/' + number + '?text=' + encodeURIComponent(text), '_blank', 'noopener');
      });
    }

    var sort = document.querySelector('[data-sort]');
    if (sort && sort.form) {
      sort.addEventListener('change', function () {
        sort.form.submit();
      });
    }
  });
})();
